/**
 * Web build stub — native DRM player is Android/iOS only.
 * Keeps webpack happy on Amplify without building plugins/capacitor-drmplayer.
 */
export const DrmPlayer = {
    play() {
        return Promise.resolve({});
    },
    addListener(_event, _handler) {
        return Promise.resolve({ remove: () => {} });
    },
};
